import React from "react";
import FormHubSpotPWC from "./FormHubSpotPWC";

export default function FaqContact() {
  return (
    <section className="bg-sidom-blue text-white py-14">
      <div className="container">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-extrabold">¿No encuentra su respuesta?</h2>
          <p className="text-2xl md:text-3xl font-semibold">Envíe la consulta</p>
        </div>

        <div className="rounded-3xl bg-gradient-to-b from-sidom-orange via-sidom-orange/85 to-sidom-blue shadow-lg p-6 md:p-10 mx-auto max-w-5xl">
          <div className="flex justify-center items-center w-full">
            <div className="w-full">
              <FormHubSpotPWC />
            </div>
          </div>
        </div>

        <p className="max-w-5xl mx-auto text-[11px] md:text-xs text-sidom-light/80 mt-6 leading-relaxed">
          El contenido del sitio web es sólo para fines informativos y no constituye consejo ni asesoramiento legal. En este sentido, dicho contenido no debe interpretarse como un sustituto del asesoramiento legal profesional, ya que cada situación es única y puede variar en su solución según las circunstancias del caso. El uso de la información de este sitio no crea una relación abogado-cliente entre Ud. y PwC Legal SRL, así como PwC Legal SRL no se responsabiliza de ninguna decisión o acción tomada en función de la información proporcionada en esta plataforma, ni de las soluciones y/o servicios ofrecidos.
        </p>
      </div>
    </section>
  );
}
